import { ChevronDown, ChevronUp } from 'lucide-react'

type DiscoverSectionProps = {
  sectionLabel: string
  isOpen: boolean
  onToggle: () => void
  isLast: boolean
  children: React.ReactNode
}

export function DiscoverSection({
  sectionLabel,
  isOpen,
  onToggle,
  isLast,
  children,
}: DiscoverSectionProps) {
  return (
    <div className={isLast ? '' : 'border-border border-b'}>
      <button
        type="button"
        onClick={onToggle}
        className="text-foreground flex w-full cursor-pointer items-center justify-between gap-4 bg-gray-100/90 px-6 py-4 text-left text-xl font-semibold transition-colors"
      >
        <span>{sectionLabel}</span>
        {isOpen ? (
          <ChevronUp className="h-4 w-4 shrink-0 text-gray-400" aria-hidden />
        ) : (
          <ChevronDown className="h-4 w-4 shrink-0 text-gray-400" aria-hidden />
        )}
      </button>
      {isOpen && <div className="border-border border-t">{children}</div>}
    </div>
  )
}
